// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Login - Tema negro y rojo de la app */
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0a0a0a 100%);
  background-image: 
    linear-gradient(135deg, rgba(166, 27, 52, 0.15) 0%, transparent 50%),
    linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0a0a0a 100%);
  padding: 20px;
}

.login-card {
  background: rgba(26, 26, 26, 0.95);
  border: 1px solid #1f2937;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5), 0 0 40px rgba(166, 27, 52, 0.08);
  padding: 48px 40px;
  width: 100%;
  max-width: 420px;
}

.login-header {
  text-align: center;
  margin-bottom: 36px;
}

.login-logos {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 0;
  margin-bottom: 12px;
}

.login-logo-xtam {
  height: 48px;
  object-fit: contain;
  filter: brightness(0) invert(1);
  vertical-align: baseline;
}

.login-vms-text {
  font-size: 28px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 0.05em;
  font-style: italic;
  line-height: 1;
  margin-left: -10px;
  transform: translateY(-5px);
}

.login-subtitle {
  color: #9ca3af;
  font-size: 14px;
  margin: 0;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-size: 14px;
  font-weight: 500;
  color: #e5e7eb;
}

.form-group input {
  padding: 12px 16px;
  border: 1px solid #374151;
  border-radius: 8px;
  font-size: 16px;
  background: #111;
  color: #ffffff;
  transition: border-color 0.2s;
}

.form-group input::placeholder {
  color: #6b7280;
}

.form-group input:focus {
  outline: none;
  border-color: #A61B34;
}

.form-group input:disabled {
  background-color: #1f2937;
  cursor: not-allowed;
  opacity: 0.7;
}

.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input-wrapper input {
  padding-right: 48px;
  width: 100%;
}

.password-toggle-btn {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
  border-radius: 4px;
}

.password-toggle-btn:hover {
  color: #ffffff;
}

.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.remember-me {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #9ca3af;
}

.remember-me input {
  width: 16px;
  height: 16px;
  accent-color: #A61B34;
}

.remember-me:hover {
  color: #e5e7eb;
}

.recover-password-link {
  font-size: 14px;
  color: #A61B34;
  text-decoration: none;
  transition: color 0.2s;
}

.recover-password-link:hover {
  color: #dc2626;
}

.login-button {
  padding: 14px;
  background: linear-gradient(135deg, #A61B34 0%, #8B1528 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.1s, box-shadow 0.2s;
  margin-top: 8px;
}

.login-button:hover:not(:disabled) {
  opacity: 0.95;
  transform: translateY(-1px);
  box-shadow: 0 4px 20px rgba(166, 27, 52, 0.4);
}

.login-button:active:not(:disabled) {
  transform: translateY(0);
}

.login-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.login-footer {
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #1f2937;
  text-align: center;
}

.login-footer p {
  font-size: 12px;
  color: #6b7280;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LoginPage.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,0EAA0E;EAC1E;;kEAEgE;EAChE,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,mBAAmB;EACnB,4EAA4E;EAC5E,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,MAAM;EACN,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yDAAyD;EACzD,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX","sourcesContent":["/* Login - Tema negro y rojo de la app */\n.login-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0a0a0a 100%);\n  background-image: \n    linear-gradient(135deg, rgba(166, 27, 52, 0.15) 0%, transparent 50%),\n    linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0a0a0a 100%);\n  padding: 20px;\n}\n\n.login-card {\n  background: rgba(26, 26, 26, 0.95);\n  border: 1px solid #1f2937;\n  border-radius: 16px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5), 0 0 40px rgba(166, 27, 52, 0.08);\n  padding: 48px 40px;\n  width: 100%;\n  max-width: 420px;\n}\n\n.login-header {\n  text-align: center;\n  margin-bottom: 36px;\n}\n\n.login-logos {\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n  gap: 0;\n  margin-bottom: 12px;\n}\n\n.login-logo-xtam {\n  height: 48px;\n  object-fit: contain;\n  filter: brightness(0) invert(1);\n  vertical-align: baseline;\n}\n\n.login-vms-text {\n  font-size: 28px;\n  font-weight: 700;\n  color: #ffffff;\n  letter-spacing: 0.05em;\n  font-style: italic;\n  line-height: 1;\n  margin-left: -10px;\n  transform: translateY(-5px);\n}\n\n.login-subtitle {\n  color: #9ca3af;\n  font-size: 14px;\n  margin: 0;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-group label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #e5e7eb;\n}\n\n.form-group input {\n  padding: 12px 16px;\n  border: 1px solid #374151;\n  border-radius: 8px;\n  font-size: 16px;\n  background: #111;\n  color: #ffffff;\n  transition: border-color 0.2s;\n}\n\n.form-group input::placeholder {\n  color: #6b7280;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #A61B34;\n}\n\n.form-group input:disabled {\n  background-color: #1f2937;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.password-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.password-input-wrapper input {\n  padding-right: 48px;\n  width: 100%;\n}\n\n.password-toggle-btn {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: transparent;\n  border: none;\n  color: #9ca3af;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s;\n  border-radius: 4px;\n}\n\n.password-toggle-btn:hover {\n  color: #ffffff;\n}\n\n.form-options {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.remember-me {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #9ca3af;\n}\n\n.remember-me input {\n  width: 16px;\n  height: 16px;\n  accent-color: #A61B34;\n}\n\n.remember-me:hover {\n  color: #e5e7eb;\n}\n\n.recover-password-link {\n  font-size: 14px;\n  color: #A61B34;\n  text-decoration: none;\n  transition: color 0.2s;\n}\n\n.recover-password-link:hover {\n  color: #dc2626;\n}\n\n.login-button {\n  padding: 14px;\n  background: linear-gradient(135deg, #A61B34 0%, #8B1528 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.2s, transform 0.1s, box-shadow 0.2s;\n  margin-top: 8px;\n}\n\n.login-button:hover:not(:disabled) {\n  opacity: 0.95;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 20px rgba(166, 27, 52, 0.4);\n}\n\n.login-button:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.login-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.login-footer {\n  margin-top: 32px;\n  padding-top: 24px;\n  border-top: 1px solid #1f2937;\n  text-align: center;\n}\n\n.login-footer p {\n  font-size: 12px;\n  color: #6b7280;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
